module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('strong', [_vm._v("II"), _c('br'), _vm._v("OUT OF THE REVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotem"
  }, [_c('em', [_vm._v("The stars have gleamed with a pitying light"), _c('br'), _vm._v("On the scene of many a hopeless fight,"), _c('br'), _vm._v("On a prairie patch or a haunted wood"), _c('br'), _vm._v("Where a little bunch of Rangers stood")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotem"
  }, [_c('em', [_vm._v("They fought grim odds and knew no fear,"), _c('br'), _vm._v("They kept their honor high and clear,"), _c('br'), _vm._v("And, facing arrows, guns, and knives,"), _c('br'), _vm._v("Gave Texas all they had—their lives")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("W. A. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HELSON")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a395013","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part02.vue
// module id = 108
// module chunks = 0